import { render, staticRenderFns } from "./editOrderModel.vue?vue&type=template&id=56c867f4&scoped=true&"
import script from "./editOrderModel.vue?vue&type=script&lang=js&"
export * from "./editOrderModel.vue?vue&type=script&lang=js&"
import style0 from "./editOrderModel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editOrderModel.vue?vue&type=style&index=1&id=56c867f4&scoped=true&lang=css&"
import style2 from "./editOrderModel.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c867f4",
  null
  
)

export default component.exports